import React from 'react';
import jwt from 'jsonwebtoken';

import { useAggregatedState } from '../../helpers';

export const AuthContext = React.createContext(null);

const checkTokenValidity = () => {
    const json = sessionStorage.getItem("token");
    if (!json) return false;
    const decodedToken = jwt.decode(JSON.parse(json).token);
    //console.debug(decodedToken);
    //console.debug();
    const expDate = new Date(decodedToken.exp * 1000);
    return (new Date()) < expDate;
}

const { Provider } = AuthContext;
export const AuthProvider = (props) => {
    const [state, setState] = useAggregatedState({
        isAuthenticated: checkTokenValidity()
    });

    const setToken = (token) => {
        sessionStorage.setItem("token", JSON.stringify(token));
        setState({ isAuthenticated: true });
    }

    const getToken = () => {
        const json = sessionStorage.getItem("token");
        if (!json || json.length === 0)
            return null;
        return JSON.parse(json).token;
    }

    const getAccountInfo = () => {
        const token = getToken();
        if (!token) return null;
        const decodedToken = jwt.decode(token);
        return {
            email: decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"],
            fullName: decodedToken.fullName,
            company: decodedToken.company
        };
    }

    const logOut = () => {
        sessionStorage.removeItem("token");
        setState({ isAuthenticated: false });
    }

    const isAuthenticated = () => {
        return checkTokenValidity();
    }

    return (
        <Provider value={{
            state,
            setToken,
            getToken,
            getAccountInfo,
            logOut,
            isAuthenticated
        }}>
            {props.children}
        </Provider>
    );
}